import { Autocomplete, TextField, Popper, Paper } from "@mui/material";

const CustomAutocomplete: React.FC<{
  options: any[];
  getOptionLabel: (option: any) => string;
  value: any;
  onChange: any;
  name: string;
  label?: string; 
  height?: string;
  required?: boolean;
  color?: string;
  fontSize?: string;
  disabled?: boolean; 
}> = ({
  options,
  getOptionLabel,
  value,
  onChange,
  name,
  label = "", 
  height = "40px",
  required = false,
  color = "#464646",
  fontSize = "14px",
  disabled = false, 
}) => {
  const customStyles = {
    width: "100%",
    maxWidth: "100%",
    "& .MuiInputBase-root": {
      height,
    },
    "& .MuiAutocomplete-option, & .MuiInputBase-input": {
      color,
      fontSize,
    },
  };
  const normalizeString = (str: string) => {
    return str.replace(/\s+/g, "").toLowerCase();
  };

  const filterOptions = (options: any[], { inputValue }: { inputValue: string }) => {
    const normalizedInput = normalizeString(inputValue);
    return options.filter((option) =>
      normalizeString(getOptionLabel(option)).includes(normalizedInput)
    );
  };
  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={onChange}
      filterOptions={filterOptions}
      sx={customStyles}
      PopperComponent={(props) => <Popper {...props} sx={customStyles} />}
      PaperComponent={(props) => <Paper {...props} sx={customStyles} />}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          label={label} 
          variant="outlined"
          size="small"
          sx={customStyles}
          required={required}
          disabled={disabled} 
        />
      )}
      disabled={disabled} 
    />
  );
};

export default CustomAutocomplete;
